import React, { useContext, useState, useEffect } from 'react'
import { FiX, FiTag, FiRefreshCw, FiPrinter, FiChevronDown, FiShare2, FiAlertTriangle, FiCheck, FiArrowUpCircle } from 'react-icons/fi'
import { toast } from 'react-toastify'
import { useMutation, useQuery } from '@tanstack/react-query'
import { FaAmbulance, FaQrcode } from 'react-icons/fa'
import { Link, useHistory } from 'react-router-dom'
import { DotLottieReact } from '@lottiefiles/dotlottie-react'
import QRCode from 'react-qr-code'
import classNames from 'classnames'

import { Container, DropdownVariacoesContainer } from './styles'
import Modal from '../../../../components/Modal'
import { Button } from '../../../../components/Form'
import { api, authHeaders } from '../../../../services/api'
import { GlobalContext } from '../../../../contexts/GlobalContext'
import carteira from '../../../../assets/images/carteira.png'
import chaveiro from '../../../../assets/images/chaveiro.png'
import broche from '../../../../assets/images/broche.png'
import adesivo from '../../../../assets/images/adesivo.png'
import neuroatipico from '../../../../assets/images/neuroatipico.png'
import neuroatipico1Demo from '../../../../assets/images/tags/demo/neuroatipico1.png'
import neuroatipico2Demo from '../../../../assets/images/tags/demo/neuroatipico2.png'
import neuroatipico3Demo from '../../../../assets/images/tags/demo/neuroatipico3.png'
import neuroatipico4Demo from '../../../../assets/images/tags/demo/neuroatipico4.png'
import neuroatipico5Demo from '../../../../assets/images/tags/demo/neuroatipico5.png'
import telaEmergenciaDemo from '../../../../assets/images/tela-emergencia-demo.png'
import scanAnimation from '../../../../assets/animations/scan.lottie'
import printerAnimation from '../../../../assets/animations/impressora.lottie'
import Dados from './Dados'
import Spinner from '../../../../components/Spinner'

export default function () {
	const { user, checkRecurso } = useContext(GlobalContext)

	const [showConfirmacaoImpressaoTag, setShowConfirmacaoImpressaoTag] = useState(false)
	const showModelosNeuroatipicoState = useState(false)
	const [showOpcoesProntuarioDropdown, setShowOpcoesProntuarioDropdown] = useState(false)
	const [QRCodeSharedURL, setQRCodeSharedURL] = useState(null)
	const [showConfirmacaoCompartilhamentoComTitular, setShowConfirmacaoCompartilhamentoComTitular] = useState(false)

	const { data: prontuario, isFetching: isFetchingProntuario, refetch: refetchProntuario } = useQuery({
		queryKey: ['get_prontuario_on_dashboard'],
		queryFn: async () => {
			const response = await api.get(`prontuario/${user.pessoa.id}`, authHeaders())

			response.assinatura = response.assinaturas.find(a => a.modulo_id === 1)

			delete response.assinaturas

			return response
		},
		refetchOnWindowFocus: false
	})

	const { mutate: handleToggleCompartilharComTitular } = useMutation({
		mutationFn: async () => {
			try {
				const novoStatus = !prontuario.assinatura.compartilhado_com_titular

				await api.put(`prontuario/compartilhamento_titular/${prontuario.assinatura.id}`, {
					compartilhado: novoStatus
				}, authHeaders())

				toast.success(novoStatus ?
					'Seu prontuário foi compartilhado com o titular da conta.' :
					'Seu prontuário não está mais compartilhado com o titular da conta.'
				)

				setShowConfirmacaoCompartilhamentoComTitular(false)

				refetchProntuario()
			} catch (e) {
				toast.error(e.msg)
			}
		}
	})

	function generateShareQRCodeURL() {
		const { token, qrcode_token } = prontuario

		const urlQRCode = `${process.env.REACT_APP_FRONTEND_URL}/emergencia/${token}/shared/${qrcode_token}`

		setQRCodeSharedURL(urlQRCode)
	}

	useEffect(() => {
		function handleClickAway(e) {
			const dropdown = document.querySelector('#opcoes-prontuario-dropdown')
			const trigger = document.querySelector('#opcoes-prontuario-trigger')

			if (!dropdown) {
				return
			}

			if (!dropdown.contains(e.target) && !trigger.contains(e.target)) {
				setShowOpcoesProntuarioDropdown(false)
			}
		}

		document.addEventListener('click', handleClickAway)

		return () => {
			document.removeEventListener('click', handleClickAway)
		}
	}, [])

	if (!user) {
		return <Spinner />
	}

	const opcoesMenuProntuario = [
		{
			show: ((checkRecurso('cartao-emergencia') || checkRecurso('inclusao-plano-individual'))) && !!prontuario,
			onClick: () => {
				setShowOpcoesProntuarioDropdown(false)

				setShowConfirmacaoImpressaoTag(true)
			},
			label: 'Meu QRCode de emergência',
			icon: <FiTag size={18} />,
			id: 'botao-imprimir-tag'
		},

		{
			show: ((checkRecurso('cartao-emergencia') || checkRecurso('inclusao-plano-individual'))) && !!prontuario,
			onClick: () => setShowOpcoesProntuarioDropdown(false),
			label: 'Acessos de emergência',
			icon: <FaAmbulance size={18} />,
			link: '/emergencia/acessos'
		},

		{
			show: !!prontuario,
			onClick: () => {
				setShowOpcoesProntuarioDropdown(false)

				generateShareQRCodeURL()
			},
			label: 'Compartilhar via QRCode',
			icon: <FaQrcode size={18} />
		},

		{
			show: !!prontuario && prontuario.assinatura && !isFetchingProntuario,
			onClick: () => {
				setShowOpcoesProntuarioDropdown(false)

				setShowConfirmacaoCompartilhamentoComTitular(true)
			},
			label: 'Compartilhar com o titular',
			icon: <FiShare2 size={18} />,
			extra: (
				<span className="col-start-2 text-slate-400" style={{ fontSize: 12 }}>
					{prontuario?.assinatura?.compartilhado_com_titular ?
						'Compartilhamento ativado' :
						'Compartilhamento desativado'
					}
				</span>
			)
		}
	]

	const opcoesMenuProntuarioVisiveis = opcoesMenuProntuario.filter(items => !!items.show)

	const compartilhamentoSuportado = !!navigator.share

	const assinaturaProntuario = user.pessoa.assinaturas.find(a => a.plano.modulo_id === 1)
	
	const ePlanoGratis = assinaturaProntuario?.plano.id === 1
	
	return (
		<>
			<Container className="flex flex-col">
				{!!opcoesMenuProntuarioVisiveis.length && (
					<details className="mx-4 sm:mb-6 md:self-end md:w-72 relative" open={showOpcoesProntuarioDropdown}>
						<summary
							id="opcoes-prontuario-trigger"
							onClick={e => {
								e.preventDefault()
								setShowOpcoesProntuarioDropdown(old => !old)
							}}
							className="select-none bg-sky-600  onClick={() => { history.push(`/assinaturas/alterar_plano?modulo=1`) }}hover:bg-sky-700 p-3 py-5 md:py-3 list-none rounded-md appearance-none cursor-pointer flex justify-between gap-4 items-center shadow-lg transition-all"
						>
							<span>Opções do Prontuário</span>
							<FiChevronDown size={18} />
						</summary>

						<ul id="opcoes-prontuario-dropdown" className="flex flex-col fadeIn animated shadow-md mx-2 absolute z-10 w-[calc(100%-16px)] md:w-[272px]">
							{opcoesMenuProntuarioVisiveis.map((opcao, idx) => {
								const isLast = idx === opcoesMenuProntuarioVisiveis.length - 1

								return (
									<li key={idx} className={classNames({ 'border-b border-b-slate-300': !isLast })}>
										{opcao.link ? (
											<Link
												to={opcao.link}
												onClick={opcao.onClick}
												className="text-sky-600 grid grid-cols-[1.6rem_1fr] items-center gap-3 justify-center p-5 w-full cursor-pointer hover:bg-slate-100 bg-white transition-all"
											>
												{opcao.icon}

												<span>{opcao.label}</span>

												{opcao.extra}
											</Link>
										) : (
											<div
												onClick={opcao.onClick}
												className="text-sky-600 grid grid-cols-[1.6rem_1fr] items-center gap-x-3 justify-center p-5 w-full cursor-pointer hover:bg-slate-100 bg-white transition-all"
											>
												{opcao.icon}

												<span>{opcao.label}</span>

												{opcao.extra}
											</div>
										)}
									</li>
								)
							})}
						</ul>
					</details>
				)}

				<Dados
					pessoaId={user.pessoa.id}
					refetchProntuario={refetchProntuario}
					prontuario={prontuario}
					isFetchingProntuario={isFetchingProntuario}
				/>
			</Container>

			<Modal
				isOpen={showConfirmacaoCompartilhamentoComTitular}
				handleClose={() => {
					setShowConfirmacaoCompartilhamentoComTitular(false)
				}}
				title="Compartilhar seu prontuário com o titular"
			>
				{prontuario?.assinatura && (
					<div className="flex flex-col gap-4 mx-2">
						{!prontuario.assinatura.compartilhado_com_titular ? (
							<p className="font-semibold">Atualmente, apenas você tem acesso ao gerenciamento do seu prontuário.</p>
						) : (
							<p className="font-semibold">Atualmente, seu prontuário está sendo compartilhado com {prontuario.assinatura.titular}.</p>
						)}

						{!prontuario.assinatura.compartilhado_com_titular ? (
							<>
								<p className="flex gap-2 items-center">
									<FiAlertTriangle size={16} className="text-yellow-700" />
									Ao compartilhar seu prontuário, o titular da conta poderá visualizar todas as suas informações médicas, assim como realizar atualizações em seu prontuário.
								</p>

								<p className="flex gap-2 items-center">
									<FiCheck size={16} className="text-emerald-600" />
									Você continuará tendo acesso total ao seu prontuário.
								</p>

								<p>Deseja realmente compartilhar seu prontuário com <span className="font-bold">{prontuario?.assinatura.titular}</span> (titular da conta)?</p>

								<div className="flex mt-4 self-end">
									<Button className="white" onClick={() => { setShowConfirmacaoCompartilhamentoComTitular(false) }}>Não</Button>
									<Button onClick={handleToggleCompartilharComTitular}>Sim</Button>
								</div>
							</>
						) : (
							<>
								<p className="flex gap-2 items-center">
									<FiAlertTriangle size={16} className="text-yellow-700" />
									Ao remover o compartilhamento, o titular da conta não poderá mais visualizar e realizar atualizações em seu Prontuário da Saúde do Cidadão.
								</p>

								<p>Deseja realmente remover o compartilhamento do seu prontuário com <span className="font-bold">{prontuario?.assinatura.titular}</span> (titular da conta)?</p>

								<div className="flex mt-4 self-end">
									<Button className="white" onClick={() => { setShowConfirmacaoCompartilhamentoComTitular(false) }}>Não</Button>
									<Button onClick={handleToggleCompartilharComTitular}>Sim</Button>
								</div>
							</>
						)}
					</div>
				)}
			</Modal>

			<Modal
				isOpen={showConfirmacaoImpressaoTag}
				handleClose={() => {
					setShowConfirmacaoImpressaoTag(false)
				}}
				title="Confirmação de impressão"
			>
				<OpcoesImpressaoTagEmergencia
					pessoaId={user.pessoa.id}
					showModelosNeuroatipicoState={showModelosNeuroatipicoState}
					refetchProntuario={refetchProntuario}
					ePlanoGratis={ePlanoGratis}
				/>
			</Modal>

			<Modal
				isOpen={!!QRCodeSharedURL}
				handleClose={() => {
					setQRCodeSharedURL(null)
				}}
				title="Escaneie o QRCode"
			>
				<div className="flex flex-col gap-4">
					<p className="font-semibold mx-2">QRCode de AUTORIZAÇÃO de ACESSO ao meu Prontuário da Saúde do Cidadão.</p>

					{QRCodeSharedURL && <QRCode value={QRCodeSharedURL} className="w-full object-contain" />}

					<p className="text-center">Escaneie este QRCode com o dispositivo para o qual deseja dar acesso ao seu prontuário.</p>

					{compartilhamentoSuportado && (
						<button
							className="py-4 px-6 sm:p-2 font-medium flex items-center gap-2 bg-slate-200 hover:bg-slate-300 rounded-md w-fit self-center transition-all"
							onClick={async () => {
								try {
									await navigator.share({
										title: 'Compartilhar prontuário',
										text: `Prontuário de ${prontuario.pessoa.nome}:\n\n${QRCodeSharedURL}`
									})
								} catch (e) {}
							}}
						>
							<FiShare2 size={17} />
							<span>Compartilhar por link</span>
						</button>
					)}
				</div>
			</Modal>
		</>
	)
}

export function OpcoesImpressaoTagEmergencia({ showModelosNeuroatipicoState, refetchProntuario, pessoaId, ePlanoGratis }) {
	const [showModelosNeuroatipico, setShowModelosNeuroatipico] = showModelosNeuroatipicoState

	const history = useHistory()

	function handlePrintTag(formato) {
		history.push(`/dashboard/prontuario/tag/${pessoaId}?formato=${formato}`)
	}

	async function handleRegenerateTag() {
		try {
			await api.patch('prontuario/tag', {}, authHeaders())

			toast.success('Uma nova TAG foi gerada para você!')

			refetchProntuario()
		} catch (e) {
			toast.error(e.msg)
		}
	}

	useEffect(() => {
		if (showModelosNeuroatipico) {
			function handleClickAway(e) {
				const dropdown = document.querySelector('#dropdown-variacao-tag-neuroatipicos')
				const button = document.querySelector('#button-variacao-tag-neuroatipicos')

				if (!dropdown) {
					return
				}

				if (!dropdown.contains(e.target) && !button.contains(e.target)) {
					setShowModelosNeuroatipico(false)
				}
			}

			document.addEventListener('click', handleClickAway)

			return () => {
				document.removeEventListener('click', handleClickAway)
			}
		}
	}, [showModelosNeuroatipico])

	return (
		<div className="flex flex-col items-center gap-5 mx-2">
			<p className="w-full">Você deve ter em mãos seu QRCode de emergência sempre que precisar de atendimento médico.</p>
			<p className="w-full">Ela contém os dados do seu prontuário, possibilitando uma análise rápida do seu perfil clínico, evitando procedimentos incorretos ou arriscados.</p>
			<p className="w-full">Modelos disponíveis:</p>

			<div className="flex flex-col lg:flex-row gap-8">
				<div className="flex flex-col items-center gap-4">
					<span className="font-semibold text-center">Cartão</span>

					<img src={carteira} alt="" className="rounded-full w-36 h-36 object-cover" />

					<Button onClick={() => { handlePrintTag('cartao') }} tiny>
						Imprimir
						<FiPrinter size={16} />
					</Button>
				</div>

				<div className="flex flex-col items-center gap-4 group">
					<span className="font-semibold text-center">Chaveiro</span>

					<img src={chaveiro} alt="" className={classNames('rounded-full w-36 h-36 object-cover')} />

					<Button 
						onClick={() => { handlePrintTag('chaveiro') }} 
						tiny 
					>
						Imprimir
						<FiPrinter size={16} />
					</Button>
				</div>

				<div className="flex flex-col items-center gap-4 group">
					<span className="font-semibold text-center">Broche</span>

					<img src={broche} alt="" className={classNames('rounded-full w-36 h-36 object-cover')} />

					<Button 
						onClick={() => { handlePrintTag('broche') }} 
						tiny 
					>
						Imprimir
						<FiPrinter size={16} />
					</Button>
				</div>

				<div className="flex flex-col items-center gap-4 group">
					<span className="font-semibold text-center">Adesivo</span>

					<img src={adesivo} alt="" className={classNames('rounded-full w-36 h-36 object-cover')} />

					<Button 
						onClick={() => { handlePrintTag('adesivo') }} 
						tiny 
					>
						Imprimir
						<FiPrinter size={16} />
					</Button>
				</div>

				<div className="flex flex-col items-center gap-4 relative group">
					<span className="font-semibold text-center">Pessoas neuroatípicas</span>

					<img src={neuroatipico} alt="" className={classNames('w-36 h-36 object-contain', { 'opacity-50': ePlanoGratis })} />

					<Button 
						onClick={() => { setShowModelosNeuroatipico(true) }} 
						tiny 
						id="button-variacao-tag-neuroatipicos" 
						disabled={ePlanoGratis}
						afterContent={(
							<div className="hidden group-hover:flex items-center animated fadeInUp faster">
								{ePlanoGratis && (
									<Button tiny className="bg-sky-600" onClick={() => { history.push(`/assinaturas/alterar_plano?modulo=1`) }}>
										<span>Faça upgrade</span>

										<FiArrowUpCircle size={15} />
									</Button>
								)}
							</div>
						)}
					>
						Escolher variação
						<FiTag size={16} />
					</Button>

					{showModelosNeuroatipico && (
						<DropdownVariacoesContainer
							id="dropdown-variacao-tag-neuroatipicos"
							className="absolute bottom-0 md:right-0 bg-white h-96 overflow-y-auto aniimated fadeIn fast p-3 flex flex-col gap-4"
							style={{
								boxShadow: '0 4px 5px 0 rgba(0, 0, 0, 0.14), 0 1px 10px 0 rgba(0, 0, 0, 0.12), 0 2px 4px -1px rgba(0, 0, 0, 0.3)',
							}}
						>
							<div className="flex justify-between gap-3 p-3">
								<h3 className="self-center font-semibold text-slate-800 hidden md:block" style={{ fontSize: 14 }}>Escolha a variação</h3>
								<h3 className="self-center font-semibold text-slate-800 md:hidden" style={{ fontSize: 17 }}>Escolha a variação</h3>
								<FiX size={18} onClick={() => { setShowModelosNeuroatipico(false) }} className="cursor-pointer hover:opacity-70 self-end hidden md:block" />
								<FiX size={26} onClick={() => { setShowModelosNeuroatipico(false) }} className="cursor-pointer hover:opacity-70 self-end md:hidden" />
							</div>

							<ul className="flex flex-col md:grid md:grid-cols-2 justify-center gap-1">
								<li onClick={() => { handlePrintTag('neuroatipico1') }} className="relative flex justify-center cursor-pointer hover:bg-gray-200 transition-all">
									<img src={neuroatipico1Demo} alt="" className="w-36 h-36 object-contain" />
								</li>
								<li onClick={() => { handlePrintTag('neuroatipico2') }} className="relative flex justify-center cursor-pointer hover:bg-gray-200 transition-all">
									<img src={neuroatipico2Demo} alt="" className="w-36 h-36 object-contain" />
								</li>
								<li onClick={() => { handlePrintTag('neuroatipico3') }} className="relative flex justify-center cursor-pointer hover:bg-gray-200 transition-all">
									<img src={neuroatipico3Demo} alt="" className="w-36 h-36 object-contain" />
								</li>
								<li onClick={() => { handlePrintTag('neuroatipico4') }} className="relative flex justify-center cursor-pointer hover:bg-gray-200 transition-all">
									<img src={neuroatipico4Demo} alt="" className="w-36 h-36 object-contain" />
								</li>
								<li onClick={() => { handlePrintTag('neuroatipico5') }} className="relative flex justify-center cursor-pointer hover:bg-gray-200 transition-all">
									<img src={neuroatipico5Demo} alt="" className="w-36 h-36 object-contain" />
								</li>
							</ul>
						</DropdownVariacoesContainer>
					)}
				</div>
			</div>

			<div className="flex flex-col items-center gap-3 mb-6">
				<span className="text-xs">Em caso de <span className="underline underline-offset-4">roubo ou furto</span> da sua TAG, você pode <span className="underline underline-offset-4">invalidá-la</span> e gerar uma nova.</span>

				<Button onClick={handleRegenerateTag} className="white w-fit self-center" tiny>
					Gerar uma nova TAG
					<FiRefreshCw size={18} />
				</Button>
			</div>

			<div className="flex flex-col gap-5 w-full">
				<h2 className="font-semibold text-slate-800" style={{ fontSize: 15 }}>Como usar o QRCode de emergência?</h2>

				<p>Quando você gera um QRCode de Emergência, ele é exclusivamente seu.</p>

				<div className="flex flex-col-reverse md:grid md:grid-cols-4">
					<DotLottieReact
						src={printerAnimation}
						loop
						autoplay
						className="w-64 h-64 justify-self-center self-center"
					/>

					<div className="flex flex-col gap-4 md:mt-12 col-span-3">
						<p>1 - Escolha o modelo desejado</p>
						<p>2 - Imprima o QRCode (ajustar o tamanho, se necessário)</p>
						<p>3 - Utilize o QRCode em lugar visível e acessível</p>
					</div>
				</div>

				<p>Em uma situação de <span className="text-red-500 font-semibold">EMERGÊNCIA</span>, basta seguir alguns passos simples:</p>

				<div className="flex flex-col-reverse md:grid md:grid-cols-4">
					<DotLottieReact
						src={scanAnimation}
						loop
						autoplay
						className="w-64 h-64 justify-self-center self-center"
					/>

					<div className="flex flex-col gap-4 md:mt-12 col-span-3">
						<p>1 - Ler o QRCode através de qualquer celular com câmera</p>
						<p>2 - Informar o CPF</p>
						<p>3 - Acessar os dados essenciais para prestação de socorro</p>
						<p>4 - Opcionalmente, é possível enviar uma mensagem automática para os contatos de emergência cadastrados</p>
					</div>
				</div>

				<p className="font-semibold">O que acontece ao ler o QRCode?</p>

				<p>Ao ler seu QRCode, o prestador de socorro terá acesso a:</p>

				<div className="flex flex-col md:grid md:grid-cols-2 gap-4 md:mb-8">
					<ul className="list-disc ml-10">
						<li>Seu nome completo</li>
						<li>Sua idade</li>
						<li>Tipo sanguíneo (fator RH)</li>
						<li>As informações básicas informadas por você (pressão alta, cardiopatia, diabetes, alergias, etc.)</li>
						<li>Doenças informadas por você</li>
						<li>Medicamentos de uso contínuo informados por você</li>
						<li>Exames e laudos médicos cadastrados por você</li>
					</ul>

					<img src={telaEmergenciaDemo} alt="" className="w-[470px] justify-self-center self-center object-contain hidden md:block" />
				</div>

				<p className="mb-8 md:hidden">O prestador de socorro tem a possibilidade de enviar uma mensagem de emergência para os seus contatos de confiança.</p>
			</div>
		</div>
	)
}